import angular from 'angular';

class principalEpdfCtrl {
    /* @ngInject */
    constructor($state, logger, PrincipalSvc, AuthSvc) {
        this.$state = $state;
        this.logger = logger;
        this.PrincipalSvc = PrincipalSvc;
        this.AuthSvc = AuthSvc;
    }

    $onInit() {
        this.resetPrincipal = angular.copy(this.principal);

        this.includes = {
            errorMessages: require('../layouts/error-messages.html'),
        };
        this.principal.epdf.paramEpdf =
            this.principal.epdf.ladProvider || (this.principal.kiss.paramKiss && this.principal.kiss.ladTypeExtern)
                ? true
                : false;
    }
    /**Verifie si on doit créer un admin ou non  */
    mustCreateAdmin() {
        return this.principal.detail.processP2p || this.principal.detail.processO2c;
    }
    //-----------------------
    // Création du DO
    //-----------------------
    validate() {
        // Vérifier qu'on a choisi de paramétre au moins un des 2 parmis ePDF et KISS
        if (this.form.$valid) {
            // On sauvegarde dans le service les données de création
            this.PrincipalSvc.setPrincipal(this.principal);

            this.PrincipalSvc.createPrincipal(this.principal).then(
                principal => {
                    if (this.mustCreateAdmin()) {
                        this.PrincipalSvc.createPrincipalAdmin(principal.detail.id, this.PrincipalSvc.getAdmin()).then(
                            () => this.$state.go('do', { tabName: 'principal' })
                        );
                    } else {
                        this.$state.go('do', { tabName: 'principal' });
                    }
                },
                error => {
                    this.logger.error('error.create_principal', error);
                }
            );
        }
    }

    prev() {
        this.PrincipalSvc.setPrincipal(this.principal);
        this.PrincipalSvc.changeCreationStep(4, 3);
        this.$state.go('app.principal.create.kiss');
    }

    //-----------------------
    // Modification du DO
    //-----------------------
    update() {
        if (this.form.$valid) {
            this.PrincipalSvc.updatePrincipal(this.principal).then(
                data => {
                    this.form.$setPristine();
                    this.logger.success('success.update', data, null, {
                        entityName: "Le Donneur d'ordre",
                    });
                },
                error => {
                    this.logger.error('error.update', error);
                }
            );
        }
    }

    cancel() {
        this.principal = angular.copy(this.resetPrincipal);
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }
}

angular.module('app.principal').component('principalEpdf', {
    templateUrl: require('./principal-epdf.html'),
    controller: principalEpdfCtrl,
    bindings: {
        ladProviders: '<',
        principal: '<',
        create: '<',
    },
});
